import {
  SHOW_COMMENT,
  HIDE_COMMENT,
  GET_COMMENTS,
  GET_COMMENTS_SUCCESS,
  GET_COMMENTS_FAILURE,
  GET_COMMENT,
  GET_COMMENT_SUCCESS,
  GET_COMMENT_FAILURE,
  ADD_COMMENT,
  ADD_COMMENT_SUCCESS,
  ADD_COMMENT_FAILURE,
  UPDATE_COMMENT_SUCCESS,
  SHOW_LIST_COMMENTS,
  HIDE_LIST_COMMENTS,
  DELETE_COMMENT,
  DELETE_COMMENT_SUCCESS,
  DELETE_COMMENT_FAILURE,
  CONSULT_COMMENT_DETERMINED,
  SAVE_COMMENT_DETERMINED,
  SUCCESS_COMMENT_DETERMINED,
  SAVE_COMMENT_DETERMINED_SUCCESS,
  SAVE_COMMENT_DETERMINED_FAILURE,
  DELETE_COMMENT_DETERMINED,
  DELETE_COMMENT_DETERMINED_SUCCESS,
  SHOW_BUTTON_COMMENTS,
  HIDE_BUTTON_COMMENTS,
  SEARCH_COMMENTS,
  SHOW_COMPARE_VERSIONS,
  HIDE_COMPARE_VERSIONS,
  SET_VERSIONS_COMPARE,
  SEARCH_COMMENTS_SUCCESS,
  SEARCH_COMMENTS_CLEAR,
  SET_IS_EMPTY_COMPARE_DATA,
  SHOW_VERSIONS,
  HIDE_VERSIONS,
  DELETE_VERSIONS,
  DELETE_VERSIONS_SUCCESS,
  SWAP_VERSIONS,
  SWAP_VERSIONS_COMPLETE,
  SWAP_VERSIONS_ERROR,
  SET_QTY_VERSIONS,
  SHOW_BUTTON_EMOJI,
  HIDE_BUTTON_EMOJI,
  SET_SOCKET_COMMENT_SCROLL,
  CLEAR_LAST_COMMENTS,
  CLEAR_FOCUS_DESCRIPTION,
  GET_USERS_TO_COMMENT,
  GET_USERS_TO_COMMENT_FAILURE,
  GET_USERS_TO_COMMENT_SUCCESS,
  CLEAN_USERS_TO_COMMENT,
  SET_IS_DOING_A_COMMENT_WITH_FILE,
  UNSET_IS_DOING_A_COMMENT_WITH_FILE,
  SET_PDF_CARROUSEL_INDEX,
  GET_PDF_PAGES,
  GET_PDF_PAGES_SUCCESS,
  GET_PDF_PAGES_FAILURE,
  SET_IS_PDF_TAG_ACTIVE,
  UNSET_IS_PDF_TAG_ACTIVE,
  UNSET_PDF_TAG_CLICKED,
  SET_PDF_TAG_CLICKED,
  SET_IMAGE_TAG_CLICKED,
  UNSET_IMAGE_TAG_CLICKED,
  SET_VIDEO_TAG_CLICKED,
  UNSET_VIDEO_TAG_CLICKED,
  SET_AUDIO_TAG_CLICKED,
  UNSET_AUDIO_TAG_CLICKED,
  GET_NEW_COMMENTS,
  GET_NEW_COMMENTS_FAILURE,
  GET_NEW_COMMENTS_SUCCESS,
  RESTORE_PREVIOUS_PDF_CARROUSEL_INDEX_SUCCESS,
  RESTORE_PREVIOUS_PDF_CARROUSEL_INDEX,
  GET_USER_MENTIONS,
  GET_USER_MENTIONS_SUCCESS,
  GET_USER_MENTIONS_FAILURE,
  REMOVE_MENTION,
  CLEAR_MENTIONS,
  SET_IS_AUDIO_TAG_ACTIVE,
  UNSET_IS_AUDIO_TAG_ACTIVE,
  SET_IS_VIDEO_TAG_ACTIVE,
  UNSET_IS_VIDEO_TAG_ACTIVE,
  SET_IS_IMAGE_TAG_ACTIVE,
  UNSET_IS_IMAGE_TAG_ACTIVE
} from "../constants/comment-types";
import { ADVANCED_SEARCH_VISIBLE } from "../constants/app-types";
import store from "../store";
import BunkeyAPI from "../api/BunkeyAPI";
import Socket from "../utils/sockets";
import {
  calculateVersionsQuantity,
  sendMentionNotification,
  validateImageSpecialExtensions
} from "../utils/index";
import { setAssetUpdatedByDart } from "../actions/MiddleViewAction";
import { sendNotification } from "../utils/index";

export const showComment = (
  itemSelected = null,
  fromKeyCollection = null,
  focusDescription = false
) => {
  return dispatch => {
    if (itemSelected) {
      if (itemSelected.documentId) {
        /* se ejecuta cuando se hace click en la notificacion de mención*/
        dispatch(
          setSelectedItem(
            itemSelected.documentId,
            itemSelected._id,
            null,
            true,
            null
          )
        );
      } else {
        dispatch(setSelectedItem(itemSelected._id, null, null, true, "bottom"));
      }
    } else {
      dispatch({ type: GET_COMMENT_FAILURE });
      dispatch({ type: SHOW_LIST_COMMENTS });
    }
    dispatch({
      type: SHOW_COMMENT,
      payload: {
        fromKeyCollection: fromKeyCollection,
        focusDescription: focusDescription
      }
    });
    dispatch({ type: ADVANCED_SEARCH_VISIBLE, payload: false });
  };
};

export const hideComment = intl => {
  return (dispatch, getState) => {
    const {
      comments: {
        itemSelected: { document },
        isDoingACommentWithFile
      }
    } = getState();

    if (!isDoingACommentWithFile) {
      if (document && document._id) {
        dispatch(setAssetUpdatedByDart(document._id));
        // dispatch({ type: "SET_ASSET_UPDATED_BY_DART", payload: { updatedAssetId: document._id } })
      }

      dispatch({ type: HIDE_COMMENT });
      dispatch({ type: HIDE_VERSIONS });
      dispatch({ type: GET_COMMENT_FAILURE });
      dispatch({ type: CLEAN_USERS_TO_COMMENT });
      dispatch({ type: UNSET_PDF_TAG_CLICKED });
      dispatch({ type: UNSET_IMAGE_TAG_CLICKED });
      dispatch({ type: UNSET_IS_IMAGE_TAG_ACTIVE });
      dispatch({ type: UNSET_IS_VIDEO_TAG_ACTIVE });
    } else {
      sendNotification(
        "info",
        intl,
        intl.formatMessage({ id: "cannot_close_dart" })
      );
    }
    dispatch({ type: ADVANCED_SEARCH_VISIBLE, payload: true });
  };
};

export const hideCommentPromise = intl => {
  return (dispatch, getState) => {
    const {
      comments: {
        itemSelected: { document },
        isDoingACommentWithFile
      }
    } = getState();
    return new Promise((resolve, reject) => {
      if (!isDoingACommentWithFile) {
        if (document && document._id) {
          dispatch(setAssetUpdatedByDart(document._id));
        }

        dispatch({ type: HIDE_COMMENT });
        dispatch({ type: HIDE_VERSIONS });
        dispatch({ type: GET_COMMENT_FAILURE });
        dispatch({ type: CLEAN_USERS_TO_COMMENT });
        dispatch({ type: UNSET_PDF_TAG_CLICKED });
        dispatch({ type: UNSET_IMAGE_TAG_CLICKED });
        dispatch({ type: UNSET_IS_IMAGE_TAG_ACTIVE });
        dispatch({ type: UNSET_IS_VIDEO_TAG_ACTIVE });
        resolve();
      } else {
        sendNotification(
          "info",
          intl,
          intl.formatMessage({ id: "cannot_close_dart" })
        );
        reject();
      }
    });
  };
};
/**
 *
 * @param {*} documentId
 * @param {*} commentId
 * @param {*} item
 * @param {*} itemSelectedFetching
 */
export const setSelectedItem = (
  documentId,
  commentId = null,
  item,
  itemSelectedFetching = true,
  socketCommentScroll = null
) => {
  return dispatch => {
    dispatch({
      type: GET_COMMENT,
      payload: { itemSelectedFetching }
    });
    const ws = store.getState().client.workclient;
    dispatch(getUsersToMention(documentId));
    BunkeyAPI({
      url: `/clients/${ws}/objects/${documentId}/comments`,
      method: "GET"
    })
      .then(resp => {
        if (resp.status === 200) {
          dispatch({
            type: SET_SOCKET_COMMENT_SCROLL,
            payload: { socketCommentScroll }
          });

          dispatch({
            type: GET_COMMENT_SUCCESS,
            payload: {
              ...resp.data,
              item: item,
              comments: resp.data.comments.map(x => {
                return {
                  ...x,
                  isHighlight: x._id === commentId
                };
              }),
              document: {
                ...resp.data.document,
                type: validateImageSpecialExtensions(
                  resp.data.document.originalURL
                )
                  ? "document"
                  : resp.data.document.type
              },
              versions: resp.data.versions.map(version => {
                return {
                  ...version,
                  document: {
                    ...version.document,
                    type: validateImageSpecialExtensions(
                      version.document.originalURL
                    )
                      ? "document"
                      : version.document.type
                  }
                };
              })
            }
          });
          const totalVersions = calculateVersionsQuantity(
            resp.data.versions,
            resp.data.document
          );
          dispatch(setQtyVersions(totalVersions));
        } else dispatch({ type: GET_COMMENT_FAILURE });
      })
      .catch(err => {
        dispatch({ type: GET_COMMENT_FAILURE });
      });
    dispatch(setIsEmptyCompareData(true));
  };
};
/**
 *
 * @param {*} workclient
 * @param {*} query
 * @param {*} order
 * @param {*} isFetching
 */
export const getComments = (workclient, query, order, isFetching = true) => {
  return dispatch => {
    dispatch({
      type: GET_COMMENTS,
      payload: {
        isFetching
      }
    });
    BunkeyAPI({
      url: query
        ? `/comments?q=${JSON.stringify(query)}&order=${JSON.stringify(order)}`
        : `/comments?order=${JSON.stringify(order)}`,
      method: "POST",
      data: {
        client: workclient
      }
    })
      .then(resp => {
        if (resp.status === 200) {
          dispatch({
            type: GET_COMMENTS_SUCCESS,
            headers: resp.headers,
            payload: resp.data,
            page: order.page
          });
        }
      })
      .catch(err => {
        dispatch({ type: GET_COMMENTS_FAILURE });
      });
  };
};

export const clearLastComments = () => {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({ type: CLEAR_LAST_COMMENTS });
      resolve();
    });
  };
};

export const createComment = (
  documentId,
  position,
  numberReply,
  comment,
  userCreator,
  versionId,
  client,
  mentions,
  type = undefined,
  attachedFile = null,
  fileTag = null,
  time
) => {
  return dispatch => {
    dispatch({ type: ADD_COMMENT });

    BunkeyAPI({
      url: `/comments/create`,
      method: "POST",
      data: {
        documentId,
        position,
        numberReply,
        comment,
        userCreator,
        versionId,
        client,
        mentions,
        type,
        attachedFile: attachedFile,
        fileTag: fileTag,
        time
      }
    })
      .then(resp => {
        if (resp.status === 200) {
          const { client, authUser } = store.getState();
          Socket.getInstance().emit("comments_client_create", {
            data: resp.data,
            channel: client.workclient,
            commentUser: authUser.user._id
          });

          dispatch({
            type: ADD_COMMENT_SUCCESS,
            payload: { ...resp.data, type }
          });
        } else {
          dispatch({ type: ADD_COMMENT_FAILURE });
        }
      })
      .catch(err => {
        dispatch({ type: ADD_COMMENT_FAILURE });
      });
  };
};

export const manageListComment = value => {
  return dispatch => {
    if (!value) {
      dispatch({ type: HIDE_LIST_COMMENTS });
    } else {
      dispatch({ type: SHOW_LIST_COMMENTS });
    }
  };
};

export const deleteComment = id => {
  return dispatch => {
    dispatch({ type: DELETE_COMMENT });
    BunkeyAPI({
      url: `/comments/${id}`,
      method: "DELETE"
    })
      .then(resp => {
        if (resp.status === 200) {
          dispatch({
            type: DELETE_COMMENT_SUCCESS,
            payload: id
          });
        }
      })
      .catch(err => {
        dispatch({ type: DELETE_COMMENT_FAILURE });
      });
  };
};

export const consultCommentDetermined = () => {
  return dispatch => {
    dispatch({ type: CONSULT_COMMENT_DETERMINED });
    BunkeyAPI({
      url: `/userComments`,
      method: "GET"
    }).then(resp => {
      dispatch({
        type: SUCCESS_COMMENT_DETERMINED,
        payload: resp.data
      });
    });
  };
};

export const saveCommentDetermined = (workclient, message) => {
  return dispatch => {
    dispatch({ type: SAVE_COMMENT_DETERMINED });
    BunkeyAPI({
      url: `/userComments/create`,
      method: "POST",
      data: {
        client: workclient,
        message: message
      }
    })
      .then(resp => {
        dispatch({ type: SAVE_COMMENT_DETERMINED_SUCCESS, payload: resp.data });
      })
      .catch(err => {
        dispatch({ type: SAVE_COMMENT_DETERMINED_FAILURE });
      });
  };
};

export const deleteCommentDetermined = id => {
  return dispatch => {
    dispatch({ type: DELETE_COMMENT_DETERMINED });
    BunkeyAPI({
      url: `/userComments/${id}`,
      method: "DELETE"
    })
      .then(resp => {
        dispatch({
          type: DELETE_COMMENT_DETERMINED_SUCCESS,
          payload: {
            id: id
          }
        });
        dispatch({ type: DELETE_COMMENT_DETERMINED });
      })
      .catch(err => {
        dispatch({ type: DELETE_COMMENT_DETERMINED });
      });
  };
};

export const iconCommentsPrivateNavbar = value => {
  return dispatch => {
    if (!value) {
      dispatch({ type: HIDE_BUTTON_COMMENTS });
    } else {
      dispatch({ type: SHOW_BUTTON_COMMENTS });
    }
  };
};

export const searchComments = value => {
  if (value.trim() !== "") {
    return dispatch => {
      dispatch({ type: SEARCH_COMMENTS });
      setTimeout(() => {
        dispatch({ type: SEARCH_COMMENTS_SUCCESS, payload: value.trim() });
      }, 100);
    };
  }
};

export const searchCommentsClear = () => {
  return dispatch => {
    dispatch({ type: SEARCH_COMMENTS_CLEAR });
  };
};
/**
 *
 * @param {*} value
 * @param {*} versionsToCompare
 * @param {*} allVersions
 */
export const showCompareVersions = (
  value,
  versionsToCompare = null,
  allVersions = null
) => {
  return dispatch => {
    if (!value) {
      dispatch({ type: HIDE_COMPARE_VERSIONS });
    } else {
      dispatch({ type: SHOW_COMPARE_VERSIONS });
      if (versionsToCompare && allVersions) {
        dispatch(setVersionsToCompare(versionsToCompare, allVersions));
      }
    }
  };
};

// export const showOrHideViewCompareVersions = (value) => {
//   return (dispatch) => {
//     !value
//       ? dispatch({ type: SHOW_COMPARE_VERSIONS })
//       : dispatch({ type: HIDE_COMPARE_VERSIONS })
//   }
// }

/**
 *
 * @param {*} versionsToCompare
 * @param {*} allVersions
 * @name setVersionsToCompare
 * @author Victor Smith
 */
export const setVersionsToCompare = (versionsToCompare, allVersions) => {
  return dispatch => {
    dispatch({
      type: SET_VERSIONS_COMPARE,
      payload: {
        versionsToCompare,
        allVersions
      }
    });
  };
};
/**
 *
 * @param {Boolean} value
 * @name setIsEmptyCompareData
 * @author Victor Smith
 */
export const setIsEmptyCompareData = value => {
  return dispatch => {
    dispatch({
      type: SET_IS_EMPTY_COMPARE_DATA,
      payload: {
        isEmptyCompareData: value
      }
    });
  };
};
/**
 *
 * @name showHideVersions
 * @author JB
 */
export const showHideVersions = () => {
  return dispatch => {
    const show = store.getState().comments.showVersions;
    dispatch({ type: show ? HIDE_VERSIONS : SHOW_VERSIONS });
  };
};

export const hideVersions = () => {
  return dispatch => {
    dispatch({ type: HIDE_VERSIONS });
  };
};

export const hideVersionsAndCompareVersions = () => {
  return dispatch => {
    dispatch({ type: HIDE_VERSIONS });
    dispatch({ type: HIDE_COMPARE_VERSIONS });
  };
};

export const deleteVersions = id => {
  return (dispatch, getState) => {
    dispatch({ type: DELETE_VERSIONS });
    BunkeyAPI({
      url: `/assetVersion/${id}`,
      method: "DELETE"
    })
      .then(resp => {
        dispatch({
          type: DELETE_VERSIONS_SUCCESS,
          payload: {
            id: id
          }
        });
        const {
          comments: { itemSelected, itemVersions }
        } = getState();
        const versionsQuantity = calculateVersionsQuantity(
          itemVersions,
          itemSelected.document
        );
        dispatch(setQtyVersions(versionsQuantity));
      })
      .catch(err => {});
  };
};

export const swapVersion = (fromId, toId, replaceActual, itemSelected) => {
  if (replaceActual) {
    return dispatch => {
      dispatch({ type: SWAP_VERSIONS });
      BunkeyAPI({
        url: `/assetVersion/changeversion/${fromId}`,
        method: "GET"
      })
        .then(resp => {
          dispatch(showComment(itemSelected));
        })
        .catch(err => {});
    };
  } else {
    return dispatch => {
      dispatch({ type: SWAP_VERSIONS });
      BunkeyAPI({
        url: `/assetVersion/${fromId}/swapVersions/${toId}`,
        method: "GET"
      })
        .then(resp => {
          dispatch({ type: SWAP_VERSIONS_COMPLETE });
          dispatch(showComment(itemSelected));
        })
        .catch(err => {
          dispatch({ type: SWAP_VERSIONS_ERROR });
        });
    };
  }
};

export const setQtyVersions = qty => {
  return dispatch => {
    dispatch({
      type: SET_QTY_VERSIONS,
      payload: {
        qtyVersions: qty
      }
    });
  };
};

export const handleShowHideEmoji = value => {
  return dispatch => {
    if (!value) {
      dispatch({ type: HIDE_BUTTON_EMOJI });
    } else {
      dispatch({ type: SHOW_BUTTON_EMOJI });
    }
  };
};
export const getUsersToMention = documentId => {
  return (dispatch, getState) => {
    const {
      client: { workclient }
    } = getState();
    dispatch({ type: GET_USERS_TO_COMMENT });
    BunkeyAPI({
      url: `/clients/${workclient}/objects/${documentId}/usersToComment?onlyGroups=${true}`,
      method: "GET"
    })
      .then(res => {
        const { adminUsers, operatorUsers } = res.data;
        dispatch({
          type: GET_USERS_TO_COMMENT_SUCCESS,
          payload: {
            adminUsersToComment: adminUsers,
            operatorsUsersToComment: operatorUsers
          }
        });
      })
      .catch(err => {
        dispatch({ type: GET_USERS_TO_COMMENT_FAILURE, payload: { err } });
      });
  };
};

export const getUsersToMentionAll = (documentId, callback) => {
  return (dispatch, getState) => {
    const {
      client: { workclient }
    } = getState();
    dispatch({ type: GET_USERS_TO_COMMENT });
    BunkeyAPI({
      url: `/clients/${workclient}/objects/${documentId}/usersToComment`,
      method: "GET"
    })
      .then(res => {
        const { adminUsers, operatorUsers } = res.data;
        // dispatch({adminUsers, operatorUsers})
        callback({ adminUsers, operatorUsers });
      })
      .catch(err => {
        console.log(err);
      });
  };
};
export const clearFocusDecription = () => dispatch =>
  dispatch({ type: CLEAR_FOCUS_DESCRIPTION });

export const updateComment = (
  commentId,
  comment,
  mentions,
  attachedFile = null
) => {
  return dispatch => {
    dispatch({ type: ADD_COMMENT });

    BunkeyAPI({
      url: `/comments/${commentId}`,
      method: "PUT",
      data: {
        comment,
        mentions,
        attachedFile
      }
    })
      .then(resp => {
        if (resp.status === 200) {
          // const { client, authUser } = store.getState()
          // Socket.getInstance().emit('comments_client_create', {
          //   data: resp.data,
          //   channel: client.workclient,
          //   commentUser: authUser.user._id,
          // })
          if (attachedFile) {
            attachedFile.mediaQualityURL = attachedFile.originalURL;
            attachedFile.lowQualityURL = attachedFile.originalURL;
          }
          dispatch({
            type: UPDATE_COMMENT_SUCCESS,
            payload: { commentId, comment, mentions, attachedFile }
          });
        } else {
          // dispatch({ type: ADD_COMMENT_FAILURE })
        }
      })
      .catch(err => {
        // dispatch({ type: ADD_COMMENT_FAILURE })
      });
  };
};

export const setIsDoingACommentWithFile = () => {
  return dispatch => {
    dispatch({ type: SET_IS_DOING_A_COMMENT_WITH_FILE });
  };
};
export const unsetIsDoingACommentWithFile = () => {
  return dispatch => {
    dispatch({ type: UNSET_IS_DOING_A_COMMENT_WITH_FILE });
  };
};

export const setPDFCarouselIndex = index => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: SET_PDF_CARROUSEL_INDEX,
        payload: {
          index: index
        }
      });
      resolve();
    });
  };
};

export const tryGetPDFPages = (
  intl,
  workclient,
  documentId,
  skip,
  limit,
  isFetching = true
) => {
  return (dispatch, getState) => {
    const {
      comments: { isFetchingPages }
    } = getState();

    if (!isFetchingPages) {
      dispatch(
        getPDFPages(intl, workclient, documentId, skip, limit, isFetching)
      );
    }
  };
};
export const getPDFPages = (
  intl,
  workclient,
  documentId,
  skip,
  limit,
  isFetching = true
) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const {
        comments: {
          itemSelected: { document }
        }
      } = getState();
      dispatch({
        type: GET_PDF_PAGES,
        payload: {
          isFetching
        }
      });

      const { selectedIndex } = store.getState().comments.itemSelected.document;
      BunkeyAPI({
        url:
          `/clients/${workclient}/objects/${documentId}/document-pages` +
          (skip ? `?skipPages=${skip}` : "") +
          (limit ? `?limitPages=${limit}` : ""),
        method: "GET",
        data: {
          client: workclient
        }
      })
        .then(resp => {
          if (resp.status === 200) {
            if (resp.data.uuid === document.uuid) {
              dispatch({
                type: GET_PDF_PAGES_SUCCESS,
                headers: resp.headers,
                payload: resp.data,
                selectedIndex
              });
              resolve();
            } else {
              dispatch(showVersionHasChangedMessage(intl));
              dispatch(restorePreviosPdfCarrouselIndex());
              dispatch({ type: GET_PDF_PAGES_FAILURE });
              reject();
            }
          }
        })
        .catch(err => {
          console.log(err);
          dispatch({ type: GET_PDF_PAGES_FAILURE });
          reject();
        });
    });
  };
};

export const setIsPdfTagActive = () => {
  return dispatch => {
    dispatch({ type: SET_IS_PDF_TAG_ACTIVE });
  };
};
export const unsetIsPdfTagActive = () => {
  return dispatch => {
    dispatch({ type: UNSET_IS_PDF_TAG_ACTIVE });
  };
};

export const setPDFCarrouselIndexWrapper = (
  tagVersionNumber,
  pdfCarrouselIndex,
  intl
) => {
  return (dispatch, getState) => {
    const {
      comments: {
        itemSelected: {
          document: { versionNumber }
        }
      }
    } = getState();
    if (tagVersionNumber === versionNumber) {
      dispatch(setPdfTagClicked(pdfCarrouselIndex));
    } else {
      sendNotification(
        "info",
        intl,
        intl.formatMessage({ id: "its_is_not_same_version" })
      );
    }
  };
};

export const setPdfTagClicked = index => (dispatch, getState) => {
  const {
    comments: { pdfCarouselIndex },
    comments: { pdfTagClicked }
  } = getState();
  if (!pdfTagClicked.isClicked && index !== pdfCarouselIndex) {
    dispatch({ type: SET_PDF_TAG_CLICKED, payload: { index } });
  }
};
export const unsetPdfTagClicked = () => {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({ type: UNSET_PDF_TAG_CLICKED });
      resolve();
    });
  };
};
export const setImagePointsWrapper = (
  tagVersionNumber,
  index,
  pointX,
  pointY,
  intl
) => {
  return (dispatch, getState) => {
    const {
      comments: {
        itemSelected: {
          document: { versionNumber }
        }
      }
    } = getState();
    if (tagVersionNumber === versionNumber) {
      dispatch(setImageTagClicked(index, pointX, pointY));
    } else {
      sendNotification(
        "info",
        intl,
        intl.formatMessage({ id: "its_is_not_same_version_imagen" })
      );
    }
  };
};
export const setImageTagClicked = (index, pointX, pointY) => (dispatch, getState) => {
  if (pointX && pointY && index) {
    dispatch({ type: SET_IMAGE_TAG_CLICKED, payload: { index:index, pointX:pointX, pointY:pointY  } });
  }
};
export const unsetImageTagClicked = () => {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({ type: UNSET_IMAGE_TAG_CLICKED });
      resolve();
    });
  };
};
export const setVideoTimeWrapper = (
  tagVersionNumber,
  time, 
  version,
  intl
) => {
  return (dispatch, getState) => {
    const {
      comments: {
        itemSelected: {
          document: { versionNumber }
        }
      }
    } = getState();
    if (tagVersionNumber === versionNumber) {
      dispatch(setVideoTagClicked(time, version));
    } else {
      sendNotification(
        "info",
        intl,
        intl.formatMessage({ id: "its_is_not_same_version_video" })
      );
    }
  };
};
export const setVideoTagClicked = (time, version) => (dispatch, getState) => {
  if (time) {
    dispatch({ type: SET_VIDEO_TAG_CLICKED, payload: { time: time, version: version} });
  }
};
export const unsetVideoTagClicked = () => {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({ type: UNSET_VIDEO_TAG_CLICKED });
      resolve();
    });
  };
};
export const setAudioTimeWrapper = (
  tagVersionNumber,
  time, 
  version,
  intl
) => {
  return (dispatch, getState) => {
    const {
      comments: {
        itemSelected: {
          document: { versionNumber }
        }
      }
    } = getState();
    if (tagVersionNumber === versionNumber) {
      dispatch(setAudioTagClicked(time, version));
    } else {
      sendNotification(
        "info",
        intl,
        intl.formatMessage({ id: "its_is_not_same_version_audio" })
      );
    }
  };
};
export const setAudioTagClicked = (time, version) => (dispatch, getState) => {
  if (time) {
    dispatch({ type: SET_AUDIO_TAG_CLICKED, payload: { time: time, version: version} });
  }
};
export const unsetAudioTagClicked = () => {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({ type: UNSET_AUDIO_TAG_CLICKED });
      resolve();
    });
  };
};
export const refreshDart = () => {
  return (dispatch, getState) => {
    const {
      comments: { fromKeyCollection, itemSelected }
    } = getState();
    dispatch(hideCommentPromise()).then(() =>
      dispatch(showComment(itemSelected.document, fromKeyCollection, false))
    );
  };
};

export const showVersionHasChangedMessage = intl => {
  return dispatch => {
    const message = intl.formatMessage({ id: "version_has_changed_message" });
    //sendNotification(type: any, intl: any, message: any, duration: number, placement: string, description: any, key: any, btnUserAction: any
    const key = `open${Date.now()}`;
    const actionToExec = () => dispatch(refreshDart());
    sendNotification(
      "errorWithUserActionWithOutAcceptButton",
      intl,
      message,
      0,
      "topRight",
      "",
      key,
      actionToExec
    );
  };
};

export const getNewComments = (
  documentId,
  commentId,
  socketCommentScroll = null
) => {
  return dispatch => {
    dispatch({ type: GET_NEW_COMMENTS });
    const ws = store.getState().client.workclient;
    dispatch(getUsersToMention(documentId));
    BunkeyAPI({
      url: `/clients/${ws}/objects/${documentId}/comments`,
      method: "GET"
    })
      .then(resp => {
        if (resp.status === 200) {
          dispatch({
            type: SET_SOCKET_COMMENT_SCROLL,
            payload: { socketCommentScroll }
          });

          dispatch({
            type: GET_NEW_COMMENTS_SUCCESS,
            payload: {
              ...resp.data,
              comments: resp.data.comments.map(x => {
                return {
                  ...x,
                  isHighlight: x._id === commentId
                };
              })
            }
          });
        } else dispatch({ type: GET_NEW_COMMENTS_FAILURE });
      })
      .catch(err => {
        console.log(err);
        dispatch({ type: GET_NEW_COMMENTS_FAILURE });
      });
    // dispatch(setIsEmptyCompareData(true))
  };
};

export function checkAsset(workclient, assetId, uuid) {
  return new Promise((resolve, reject) => {
    BunkeyAPI({
      url: `/clients/${workclient}/is-current-asset/${assetId}/uuid/${uuid}`,
      method: "GET"
    })
      .then(res => {
        resolve(res.data.isCurrentAssetByUUID);
      })
      .catch(err => {
        console.log(err);
        reject(false);
      });
  });
}

export const restorePreviosPdfCarrouselIndex = () => dispatch =>
  dispatch({ type: RESTORE_PREVIOUS_PDF_CARROUSEL_INDEX });
export const restorePreviosPdfCarrouselIndexSuccess = () => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch({ type: RESTORE_PREVIOUS_PDF_CARROUSEL_INDEX_SUCCESS });
    resolve();
  });
};

export const showMentionOnComment = comment => {
  return dispatch => {
    dispatch(removeMention(comment._id));
    dispatch(setViewComment(comment));
    dispatch(showComment(comment));
  };
};

export const setViewComment = comment => {
  return dispatch => {
    BunkeyAPI({
      url: `comments/${comment._id}/setViewComment`,
      method: "PUT"
    })
      .then(resp => {})
      .catch(err => {
        console.log(err);
      });
  };
};

export const getUserMentions = (workclient, intl) => {
  return dispatch => {
    dispatch({ type: GET_USER_MENTIONS });
    BunkeyAPI({
      url: `clients/${workclient}/mentions`,
      method: "GET"
    })
      .then(resp => {
        const { mentions } = resp.data;

        dispatch({ type: GET_USER_MENTIONS_SUCCESS, payload: { mentions } });
        mentions.forEach(mention => {
          const message = `${intl.formatMessage({ id: "mentionUserComment" })}${
            mention.userCreator.name
          }`;
          const goToCommentAction = () =>
            dispatch(showMentionOnComment(mention));

          const ignoreCommentAction = () => {};
          sendMentionNotification(
            intl,
            message,
            99999,
            "topRight",
            `${mention.comment}`,
            `mention_${mention.commentId}`,
            goToCommentAction,
            ignoreCommentAction
          );
        });
      })
      .catch(err => {
        dispatch({ type: GET_USER_MENTIONS_FAILURE });
      });
  };
};
export const removeMention = commentId => {
  return dispatch => {
    dispatch({ type: REMOVE_MENTION, payload: { commentId } });
  };
};

export const clearMentions = () => dispatch =>
  dispatch({ type: CLEAR_MENTIONS });

export const setIsAudioTagActive = audioTime => {
  return dispatch => {
    dispatch({
      type: SET_IS_AUDIO_TAG_ACTIVE,
      payload: { audioTime: audioTime }
    });
  };
};
export const unsetIsAudioTagActive = () => {
  return dispatch => {
    dispatch({ type: UNSET_IS_AUDIO_TAG_ACTIVE });
  };
};
export const setIsVideoTagActive = videoTime => {
  return dispatch => {
    dispatch({
      type: SET_IS_VIDEO_TAG_ACTIVE,
      payload: { videoTime: videoTime }
    });
  };
};
export const unsetIsVideoTagActive = () => {
  return dispatch => {
    dispatch({ type: UNSET_IS_VIDEO_TAG_ACTIVE });
  };
};
export const setIsImageTagActive = (
  imageXPer,
  imageYPer,
  imagePoint,
  imageTagWidth,
  imageTagHeight
) => {
  return dispatch => {
    dispatch({
      type: SET_IS_IMAGE_TAG_ACTIVE,
      payload: {
        imageTagXPer: imageXPer,
        imageTagYPer: imageYPer,
        imagePoint: imagePoint,
        imageTagWidth: imageTagWidth,
        imageTagHeight: imageTagHeight
      }
    });
  };
};
export const unsetIsImageTagActive = () => {
  return dispatch => {
    dispatch({ type: UNSET_IS_IMAGE_TAG_ACTIVE });
  };
};
